export type ReputationLevelKey = "newcomer" | "fan" | "tactician" | "oracle" | "legend";

export interface ReputationLevel {
  key: ReputationLevelKey;
  label: string;
  emoji: string;
  min: number;
  color: string;
}

export const REPUTATION_LEVELS: ReputationLevel[] = [
  { key: "newcomer",  label: "Colaborador",       emoji: "🏅", min: 0,    color: "oklch(0.7 0.05 250)" },
  { key: "fan",       label: "Fan Activo",        emoji: "🏅", min: 50,   color: "oklch(0.75 0.15 200)" },
  { key: "tactician", label: "Fan Influyente",    emoji: "🏅", min: 200,  color: "oklch(0.78 0.18 145)" },
  { key: "oracle",    label: "Líder de Afición",  emoji: "🏅", min: 600,  color: "oklch(0.78 0.2 280)" },
  { key: "legend",    label: "Embajador Mundial", emoji: "🏅", min: 1500, color: "oklch(0.85 0.18 85)" },
];

export function reputationLevelFor(points: number): {
  current: ReputationLevel;
  next: ReputationLevel | null;
  progress: number;
} {
  let current = REPUTATION_LEVELS[0];
  for (const l of REPUTATION_LEVELS) if (points >= l.min) current = l;
  const idx = REPUTATION_LEVELS.indexOf(current);
  const next = idx < REPUTATION_LEVELS.length - 1 ? REPUTATION_LEVELS[idx + 1] : null;
  const progress = next
    ? Math.min(100, ((points - current.min) / (next.min - current.min)) * 100)
    : 100;
  return { current, next, progress };
}

export interface PredictionScoreRow {
  user_id: string;
  total_points: number;
  exact_predictions: number;
  predictions_total: number;
  streak_current: number;
  streak_best: number;
  last_prediction_at: string | null;
}

export interface FeaturedFanRow {
  user_id: string;
  display_name: string;
  avatar_url: string | null;
  favorite_team: string | null;
  total_points: number;
  exact_predictions: number;
  streak_current: number;
  streak_best: number;
}